import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import { Tooltip } from 'bootstrap';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        // CSRF token for the update route (DDT-4012), sent as X-CSRF-Token like calendar_disconnect_controller.
        token: String,
    };

    // DDT-4298: the padlock tooltips keep 16px off the screen edges. Popper's default lets the
    // 340px box run flush to the edge of a phone. app.js may have initialised them already.
    connect() {
        this.element.querySelectorAll('[data-justifit-plus-lock-for]').forEach((lock) => {
            Tooltip.getInstance(lock)?.dispose();
            new Tooltip(lock, {
                popperConfig: (config) => ({
                    ...config,
                    modifiers: config.modifiers.map((modifier) => ('preventOverflow' === modifier.name
                        ? { ...modifier, options: { ...modifier.options, padding: 16 } }
                        : modifier)),
                }),
            });
        });
    }

    // Toggle a single "hors barreau" or "hors barreau + AJ" opt-in. DDT-3901.
    toggle(event) {
        const input = event.target;
        const type = input.dataset.optinType; // 'hors_barreau' | 'aj'
        const termId = input.dataset.specialismTermId;
        const value = input.checked;

        input.disabled = true;

        $.ajax({
            url: routes['app_profile_justifitplusupdate'],
            method: 'POST',
            headers: { 'X-CSRF-Token': this.tokenValue },
            // An invalid token answers 403 and lands in error() below, like any other failure.
            data: {
                type: type,
                specialismTermId: termId,
                value: value ? 'true' : 'false',
            },
            success: (response) => {
                if (response.status) {
                    this.applyCascade(type, termId, value);
                } else {
                    this.revert(input, value);
                }
                input.disabled = false;
            },
            error: () => {
                this.revert(input, value);
                input.disabled = false;
            },
        });
    }

    // Opting out of "hors barreau" also drops "+ AJ" for that area (the server cascades; mirror it in the UI).
    // Opting in re-enables the AJ toggle (left unchecked — the lawyer opts into AJ separately).
    applyCascade(type, termId, value) {
        if ('hors_barreau' !== type) {
            return;
        }

        const aj = this.element.querySelector(`input[data-justifit-plus-aj-for="${termId}"]`);

        if (!aj) {
            // AJ is locked for this area: the padlocked switch only recedes with "hors barreau".
            const lock = this.element.querySelector(`[data-justifit-plus-lock-for="${termId}"]`);
            lock?.classList.toggle('justifit-plus-lock--muted', !value);

            return;
        }

        if (value) {
            aj.disabled = false;
        } else {
            aj.checked = false;
            aj.disabled = true;
        }
    }

    revert(input, value) {
        input.checked = !value;
        addAlert('danger', translations['profile.An unknown error occurred.']);
    }
}
